define("settings/components/cancel-plan/modal/success", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@onClose}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header
        @title={{if
          this.hasActiveTrial
          (t "account.change_plan.cancellation_feedback.success_trial" planName=this.planName)
          (t "account.change_plan.cancellation_feedback.success" planName=this.planName)
        }}
      />
      <modal.card-body>
        <p>
          {{#if this.hasActiveTrial}}
            {{t
              "account.change_plan.cancellation_feedback.thanks_trial"
              activeUntil=this.activeUntil
              planName=this.planName
            }}
          {{else}}
            {{t "account.change_plan.cancellation_feedback.thanks" activeUntil=this.activeUntil planName=this.planName}}
          {{/if}}
        </p>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @onClick={{@onClose}}
          @size="regular"
          @text={{t "shared_words.done"}}
          @variant="outline"
          class="u--float--right"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "GQ4U+h3k",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[52,[30,0,[\"hasActiveTrial\"]],[28,[37,2],[\"account.change_plan.cancellation_feedback.success_trial\"],[[\"planName\"],[[30,0,[\"planName\"]]]]],[28,[37,2],[\"account.change_plan.cancellation_feedback.success\"],[[\"planName\"],[[30,0,[\"planName\"]]]]]]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,\"\\n\"],[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"          \"],[1,[28,[35,2],[\"account.change_plan.cancellation_feedback.thanks_trial\"],[[\"activeUntil\",\"planName\"],[[30,0,[\"activeUntil\"]],[30,0,[\"planName\"]]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,2],[\"account.change_plan.cancellation_feedback.thanks\"],[[\"activeUntil\",\"planName\"],[[30,0,[\"activeUntil\"]],[30,0,[\"planName\"]]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,3],[[24,0,\"u--float--right\"]],[[\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[30,1],\"regular\",[28,[37,2],[\"shared_words.done\"],null],\"outline\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@onClose\",\"modal\"],false,[\"shared/modal\",\"if\",\"t\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/cancel-plan/modal/success.hbs",
    "isStrictMode": false
  });
  let SuccessComponent = _exports.default = (_class = class SuccessComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "subscriptions", _descriptor, this);
    }
    get activeUntil() {
      return this.subscription.activeUntil;
    }
    get hasActiveTrial() {
      return this.subscriptions.hasActiveTrial;
    }
    get subscription() {
      return this.subscriptions.subscription;
    }
    get planName() {
      return this.subscription.name;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SuccessComponent);
});